import { render, staticRenderFns } from "./ProposalParticipantItem.vue?vue&type=template&id=6f7e0b29&scoped=true"
import script from "./ProposalParticipantItem.vue?vue&type=script&lang=ts"
export * from "./ProposalParticipantItem.vue?vue&type=script&lang=ts"
import style0 from "./ProposalParticipantItem.vue?vue&type=style&index=0&id=6f7e0b29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7e0b29",
  null
  
)

export default component.exports